<template>
  <div v-loading="loading" class="drawer-salary-result" style="position:relative">
    <div v-if="hangye && radish.职能模块 && radish.职能模块.length > 0" class="drawer-salary-cate" style="margin:5px 0">
      当前行业/职能模块：
      <b>
        {{ hangye }} {{ Array.isArray(radish.职能模块) ? radish.职能模块[0] : radish.职能模块 }}
        {{ radish.细分职能 && radish.细分职能.length > 0 ? `（${radish.细分职能[0]}）` : '' }}
      </b>
    </div>
    <div v-else>请先填写行业、职能模块、职级，系统才能匹配薪酬</div>
    <div v-if="result">
      <div class="rdv-salary-tabs">
        <div
          v-for="(zhi, key) in zhijiOpt"
          :key="key"
          class="rdv-salary-tab"
          :class="{ 'rdv-salary-tab-active': activeZhiji == key }"
          @click="activeZhiji = key"
        >
          {{ zhi }}
        </div>
      </div>
      <div v-for="(zhi, key) in zhijiOpt" v-show="activeZhiji == key" :key="key">
        <div v-if="result[key]" class="drawer-salary-box">
          <div class="drawer-salary-content">
            <div class="drawer-salary-row" style="border:none">
              <div class="drawer-salary-col drawer-salary-dark">单位:万</div>
              <div class="drawer-salary-col" style="background:#eee;color:#444">年固薪</div>
              <div v-if="hangye != 'PE'" class="drawer-salary-col" style="background:#eee;color:#444">年奖金</div>
              <div class="drawer-salary-col" style="background:#eee;color:#444">总薪酬</div>
            </div>
            <div class="drawer-salary-row">
              <div class="drawer-salary-col drawer-salary-dark">市场平均</div>
              <div class="drawer-salary-col">{{ result[key].固薪平均 || '-' }}</div>
              <div v-if="hangye != 'PE'" class="drawer-salary-col">{{ result[key].奖金平均 || '-' }}</div>
              <div class="drawer-salary-col">{{ result[key].薪酬平均 || '-' }}</div>
            </div>
            <div class="drawer-salary-row">
              <div class="drawer-salary-col drawer-salary-dark">90分位</div>
              <div class="drawer-salary-col">{{ result[key].固薪90 || '-' }}</div>
              <div v-if="hangye != 'PE'" class="drawer-salary-col">{{ result[key].奖金90 || '-' }}</div>
              <div class="drawer-salary-col">{{ result[key].薪酬90 || '-' }}</div>
            </div>
            <div class="drawer-salary-row">
              <div class="drawer-salary-col drawer-salary-dark">75分位</div>
              <div class="drawer-salary-col">{{ result[key].固薪75 || '-' }}</div>
              <div v-if="hangye != 'PE'" class="drawer-salary-col">{{ result[key].奖金75 || '-' }}</div>
              <div class="drawer-salary-col">{{ result[key].薪酬75 || '-' }}</div>
            </div>
            <div class="drawer-salary-row">
              <div class="drawer-salary-col drawer-salary-dark">50分位</div>
              <div class="drawer-salary-col">{{ result[key].固薪50 || '-' }}</div>
              <div v-if="hangye != 'PE'" class="drawer-salary-col">{{ result[key].奖金50 || '-' }}</div>
              <div class="drawer-salary-col">{{ result[key].薪酬50 || '-' }}</div>
            </div>
            <div class="drawer-salary-row">
              <div class="drawer-salary-col drawer-salary-dark">25分位</div>
              <div class="drawer-salary-col">{{ result[key].固薪25 || '-' }}</div>
              <div v-if="hangye != 'PE'" class="drawer-salary-col">{{ result[key].奖金25 || '-' }}</div>
              <div class="drawer-salary-col">{{ result[key].薪酬25 || '-' }}</div>
            </div>
            <div class="drawer-salary-row">
              <div class="drawer-salary-col drawer-salary-dark">10分位</div>
              <div class="drawer-salary-col">{{ result[key].固薪10 || '-' }}</div>
              <div v-if="hangye != 'PE'" class="drawer-salary-col">{{ result[key].奖金10 || '-' }}</div>
              <div class="drawer-salary-col">{{ result[key].薪酬10 || '-' }}</div>
            </div>
          </div>
        </div>
        <div v-else class="drawer-salary-box">
          <div class="drawer-salary-content">
            <div class="drawer-salary-row" style="border:none">
              <div class="drawer-salary-col drawer-salary-dark">单位:万</div>
              <div class="drawer-salary-col" style="background:#eee;color:#444">年固薪</div>
              <div v-if="hangye != 'PE'" class="drawer-salary-col" style="background:#eee;color:#444">年奖金</div>
              <div class="drawer-salary-col" style="background:#eee;color:#444">总薪酬</div>
            </div>
            <div class="drawer-salary-row" style="text-align: center">暂无数据</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>暂无数据</div>
    <div style="position:absolute;bottom:-22px;right:5px;color:#ccc;font-style:italic">来自圆手查薪酬</div>
  </div>
</template>
<script>
export default {
  props: {
    radish: Object,
  },
  data() {
    return {
      zhijiOpt: [],
      zyzj: {
        MD: 'MD',
        ED: 'ED',
        D: 'D',
        AD: 'AD',
        VP: 'VP',
        A: 'A',
        AN: 'AN',
      },
      zj: {
        '1': '1.高管',
        '2': '2.部门总',
        '3': '3.部门副总/总助/团队长',
        '4': '4.部门核心骨干',
        '5': '5.新人三年以下',
      },
      result: null,
      activeZhiji: null,
      hangye: '',
      loading: false,
    }
  },
  mounted() {
    this.loadSalary()
  },
  methods: {
    async loadSalary() {
      this.loading = true
      this.hangye = this.radish.行业 || (this.radish.目标行业 && this.radish.目标行业[0])
      const cate =
        this.radish.职能模块 && !Array.isArray(this.radish.职能模块) ? [this.radish.职能模块] : this.radish.职能模块
      if (!this.hangye || cate.length == 0) {
        this.loading = false
        return (this.result = null)
      }
      this.zhijiOpt = this.hangye == '证券' ? this.zyzj : this.zj
      this.activeZhiji = Object.keys(this.zhijiOpt)[1]
      if (this.hangye == '证券') {
        if (Array.isArray(this.radish.专业职级)) {
          if (this.radish.专业职级[0]) this.activeZhiji = this.radish.专业职级[0]
        } else if (this.radish.专业职级) this.activeZhiji = this.radish.专业职级
      } else if (Array.isArray(this.radish.职级)) {
        if (this.radish.职级[0]) this.activeZhiji = this.radish.职级[0]
      } else if (this.radish.职级) this.activeZhiji = this.radish.职级 || Object.keys(this.zhijiOpt)[1]
      let hangye = this.hangye
      if (/PE/gi.test(this.hangye)) {
        hangye = 'PE'
      }
      const form = {
        行业: hangye,
        职能模块: cate[0],
      }
      if (this.radish.细分职能) {
        if (Array.isArray(this.radish.细分职能) && this.radish.细分职能.length > 0) {
          form.细分职能 = this.radish.细分职能[0]
        } else {
          form.细分职能 = this.radish.细分职能
        }
      }
      const res = await app.service('radish').getHangyeSalary(form)
      if (res.status == 'success' && res.data) {
        this.result = res.data
      } else {
        this.result = null
      }
      this.loading = false
    },
  },
}
</script>
<style scoped>
.rdv-salary-tabs {
  display: flex;
}
.rdv-salary-tab {
  padding: 3px 10px;
  margin-right: 2px;
  background-color: #eee;
  border-radius: 5px;
  cursor: pointer;
}
.rdv-salary-tab.rdv-salary-tab-active {
  background-color: #409eff;
  color: #fff;
}
</style>
